import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';
import { Isenf } from '../isenf';
// import { newtonRaphson } from '../newtonRaphson';


import * as math from 'mathjs';


// import mathjs from 'mathjs';
// import { sqrt } from 'mathjs';
// import { derivative, evaluate, compile } from 'mathjs';
// import * as nrm from 'newton-raphson-method';


import { Senf } from '../senf';


@Component({
    selector: 'app-if-aas',
    templateUrl: './if-aas.component.html',
    styleUrl: './if-aas.component.scss',
    standalone: false
})
export class IfAasComponent {

  areaRatioForm: FormGroup | undefined;
  ickabod: Isenf | undefined;
  asenf: Senf | undefined;
  aBool?: boolean;

  constructor(private builder: FormBuilder, private isentropicService: IsentropicService) { }
  ngOnInit(): void {


    this.areaRatioForm = this.builder.group({
    options: ['1'],
    areaRat: ['', [
            Validators.required,
            Validators.min(1.0000001)
            ]],
    gammaVal: ['', [
            Validators.required,
            Validators.min(1.000001),
            Validators.max(1.68)
            ]]
    });
}

onSubmit() {
  this.aBool = true;
  this.asenf = new Senf();
  this.asenf!.areaRat = this.areaRatioForm?.get('areaRat')?.value;
  this.asenf!.gammaVal = this.areaRatioForm?.get('gammaVal')?.value;
  // this.ickabod!.areaRat = this.areaRatioForm?.get('gammaVal')?.value;           
  // this.ickabod!.gammaVal = this.areaRatioForm?.get('gammaVal')?.value;

  if  (this.areaRatioForm?.get('options')?.value === '1') {
    console.log("sub");
      let mach_sub = this.m_from_ar(
          this.areaRatioForm?.get('gammaVal')?.value, 
          this.areaRatioForm?.get('areaRat')?.value, 
          .5);
          console.log("mach_sub");
          console.log(mach_sub);
      this.asenf!.machVal = Number(mach_sub);

  } else if (this.areaRatioForm?.get('options')?.value === '2') {
    console.log("sup");
      let mach_sup = this.m_from_ar(
          this.areaRatioForm?.get('gammaVal')?.value, 
          this.areaRatioForm?.get('areaRat')?.value, 
          10);
      // let myMachSup = this.supersonicBisection(this.areaV, this.gammaV);
      this.asenf!.machVal = Number(mach_sup);
  }

  this.asenf?.senfCalc(Number(this.areaRatioForm?.get('gammaVal')?.value), this.asenf!.machVal);

  console.log(this.asenf);
}

get areaRatio() {
  return this.areaRatioForm?.get('areaRat')
}

get gamma() {
  return this.areaRatioForm?.get('gammaVal');
}


myNewton(func:string, inputIterations:number, inputInitial:number) {
  const iterations = inputIterations || 100;
  const initial = inputInitial || 0;
  const funcCompiled = math.compile(func);
  const dydx = math.derivative(func, 'x');

  let r = initial
  for (let i = 0; i < iterations; i++) {
      r = r - funcCompiled.evaluate({ x: r }) / dydx.evaluate({ x: r })
  }
  return r
}


m_from_ar(ga:string, ARatio:string, guess:number) {

  let g = Number(ga);
  let gp1 = g + 1;
  let gm1 = g - 1;

  let gp1s = gp1.toString();
  let gm1s = gm1.toString();

  // let ar = Number(ARatio);
  //  (1 + ( (gm1 / 2) * M2 ));


  // function f(x:number) {
  //     let M2 = Math.pow(x, 2);
  //     let inner = (2 / gp1) * (1 + ((gm1 / 2) * M2));
  //     // console.log("f(M_old)", inner)
  //     return Math.pow( inner, ( gp1 / (2 * gm1) ) ) - (x * ar);
  // }

  // ( 2 / ( ${ga} + 1 )) * (1 + ( (  (${ga}-1) / 2) * x^2) )^ (  ( ${ga} + 1 ) / (2 * (${ga}-1)) ) - (x * ${ARatio})

  // function fp(x:number) {
  //     let M2 = Math.pow(x, 2);
  //     let frac_exp = (gp1 / (2 * gm1)) - 1;
  //     let result = Math.pow(2 / gp1, frac_exp) * x * Math.pow(1 + (gm1 * M2) / 2, frac_exp);
  //     // console.log("dfdm(M_old)", result);
  //     return result - ar;
  // }

  // let innerStr:string = "(  (2 / (g+1)) * ( 1 + ( ((g+1)/2) * (x^2) ) ) ) ";
  // let myF:string = "((2 / ( ${ga}+1)) * ( 1 + ( ((${ga}+1)/2) * (x^2) ) ) )^( (${ga}+1) / (2* (${ga}-1))) - (x * ${ARatio})";
  // let myF:string = "((2 / ( ${ga}+1)) * ( 1 + ( ((${ga}+1)/2) * (x^2) ) ) )^( (${ga}+1) / (2* (${ga}-1))) - (x * ${ARatio})";
  // let myF:string = `( 2 / ( ${gp1s} )) * (1 + ( (  (${gm1s} ) / 2) * x^2) )^ (  ( ${gp1s} ) / (2 * (${gm1s})) ) - (x * ${ARatio})`;


  let myF:string = `( ( 1  + (${gm1s}/2) * x^2 ) * (2/${gp1s}) )^ ( (${gp1s}/(2*${gm1s}) ) - ${ARatio}`;

   


  let a1:string = `1 + ((${ga} - 1)/2)`;
  let a2:string = '(1/x)';
  let a3:string = `(${ga}+1)/2`;
  let a4:string = 'x^2';
  let a5:string = `( 1/2 * (${ga} + 1) / (${ga}-1 ) )`;


  let bigG:string = `${a2} * ( ( ${a1} * ${a4} ) / ${a3} )^${a5} - ${ARatio}`;


  // let topG:string = `(1/x) * ( ( 1 + (${ga} - 1))/2 ) / ( (${ga} + 1)/2 ) )`

  let topG:string = `( 1/x ) *  ( ( ( ( ( 1 + ( ${ga} - 1 ) ) / 2 ) * x^2 )  / ( (${ga} + 1 ) / 2 ) ) ^ ( ( ${ga} + 1 ) / (2 * ( ${ga} - 1 ) ) )  ) - ${ARatio}`;

 
  // const funcCompiled = math.compile(topG)
  // console.log("compiled function");
  // console.log(funcCompiled.toString());
  // const dydx = math.derivative(topG, 'x');
  // console.log("derivative");
  // console.log(dydx.toString());
  // const dydx = math.derivative(func, 'x')
  // console.log(math.derivative(topG, 'x').toString());

  let part_1 = (2 / gp1);
  // console.log(part_1.toString());

  let part_2 = gm1/2;
  // console.log(part_2.toString());

  let thing1:string = `${part_1.toString()} * (1 + ( ${part_2.toString()} * x^2 ) )`;

  let part_3 = gp1 / (2 * gm1);

  let thing11 = part_3.toString();

  // console.log(thing1);
  
  let thing2:string = `( (1/x) * ${thing1}^${thing11} ) - ${ARatio}`;

  // console.log(thing2);
  // ( (1/x) * 0.8333333333333334 * (1 + ( 0.19999999999999996 * x^2 ) )^3.0000000000000004 ) - 1.5
  // let myF:string =  "x^2";
  // console.log(myF);
  // console.log(math.derivative(thing2, 'x').toString());
  // ( ( 2 / ( ${ga}+1 ) ) * ( 1 + ( ((${ga}+1)/2) * (x^2) ) ) )^( (${ga}+1) / (2* (${ga}-1))) - (x * ${ARatio} )
  // let myresult:number = newtonRaphson(guess, 1e-7, myF).result;
  // let myresult:any = newtonRaphson(guess, 1e-10, topG);
  // console.log("my result: ");
  // console.log(myresult);

  const topG2:string = `(((${ga}+1)/2)^-((${ga}+1)/(${ga}-1)/2)) / x * (1 + x^2 * (${ga}-1)/2)^((${ga}+1)/(${ga}-1)/2) - ${ARatio}`;

  // console.log('new thing: ');
  // console.log(this.myNewton(topG2, 100, guess));
  // console.log(topG2);

  return this.myNewton(topG2, 100, guess)

  // return 0;
  // return myresult.result;
  // return nrm(f, fp, guess, { maxIter: 50 }).toFixed(2);
}

isenMach() {
  return this.asenf?.machVal;
}

isenp_pt() {
  return this.asenf?.pressureRat;
}

isenT_Tt() {
  return this.asenf?.tempRat;
}

isenpA_ptAstar() {
return this.asenf?.paptas;
}

isenpm() {
return this.asenf?.pmr;
}

isenmach_angle() {
return this.asenf?.machAng;
}


isen_cfopt() {
return this.asenf?.cfOpt;
}

isen_rhot() {
return this.asenf?.rhorhot;
}

}
